import { LatLng } from "@ghostgroup/wm-sdk-js/dist/types/modules/geo/types";
export default class WmlCookie {
  static extractWmlCookie(): LatLng | undefined {
    try {
      const cookie_str = "; " + document.cookie;
      const parts = cookie_str.split("; " + "_wml" + "=");
      if (parts.length == 2) {
        const cookieValue = parts.pop()?.split(";").shift();

        if (cookieValue) {
          const decoded = decodeURIComponent(cookieValue);
          return JSON.parse(decoded);
        }
      }

      return undefined;
    } catch (e) {
      return undefined;
    }
  }
}
